/**
 * Canonicalizes the Cognito login identifier before it is used for sign-in.
 * The PWA owns this deliberately small rule; it must not depend on the
 * archived Synphant monorepo.
 */
export function normalizeEmail(input: string): string {
  if (typeof input !== 'string') {
    throw new Error('normalizeEmail: input must be a string');
  }

  const trimmed = input.trim();
  if (!trimmed) {
    throw new Error('normalizeEmail: email is required');
  }

  return trimmed.toLowerCase();
}
